/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_CreditsInputs */

const en_landing_pricing_compare_credits = /** @type {(inputs: Landing_Pricing_Compare_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI autofill runs`)
};

const zh_landing_pricing_compare_credits = /** @type {(inputs: Landing_Pricing_Compare_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 自动填充次数`)
};

/**
* | output |
* | --- |
* | "AI autofill runs" |
*
* @param {Landing_Pricing_Compare_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_credits = /** @type {((inputs?: Landing_Pricing_Compare_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_credits(inputs)
	return zh_landing_pricing_compare_credits(inputs)
});
export { landing_pricing_compare_credits as "landing.pricing.compare_credits" }